import { useTranslation } from 'react-i18next';
import { More } from '../../assets/icons';
import { useCompanyPermissions } from '../../hooks/useCompanyPermissions';
import { useNavigateWithSearchParam } from '../../hooks/useNavigateWithSearchParam';
import { ComputedPromotionStatus, Promotion } from '../../stores/types/promotions.interface';
import { Menu, MenuItem } from '../_ui';
import { buildAddPromoCodePath, buildPromotionViewPath } from './promotion.utils';

const PromotionGridMenu = ({ promotion }: { promotion: Promotion }) => {
  const { t } = useTranslation();
  const { canViewPromotion, canCreatePromotion } = useCompanyPermissions(promotion.companyId);
  const { navigateWithCompanyId, navigate } = useNavigateWithSearchParam();

  // Archived promotions are view-only — new codes can't be added, so only "View" shows.
  const isArchived = promotion.status === ComputedPromotionStatus.DELETED;

  return (
    <Menu placement='bottom-end' icon={More} iconAlt={t('icon_alt_more_options')}>
      <MenuItem
        label={t('view_promotion')}
        disabled={!canViewPromotion}
        onClick={() =>
          navigateWithCompanyId(buildPromotionViewPath(promotion.promotionId), promotion.companyId)
        }
      />

      {!isArchived && (
        <MenuItem
          label={t('add_promo_code')}
          disabled={!canCreatePromotion}
          onClick={() =>
            navigate(buildAddPromoCodePath(promotion.promotionId, promotion.companyId))
          }
        />
      )}
    </Menu>
  );
};

export default PromotionGridMenu;
